// Backend host derived from the API URL by stripping the trailing /api.
// Uploaded files live at `${BACKEND_HOST}/uploads/...` and are served by the
// Express static handler in backend/src/index.ts. The FE never serves uploads
// itself — nothing user-uploaded lives in the frontend tree.
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const BACKEND_HOST = API_URL.replace(/\/api\/?$/, '');

/**
 * Turn a stored upload path into a fully-qualified URL pointing at the backend.
 * Accepts:
 *   - relative paths like `/uploads/admissions/foo.jpg` or `uploads/admissions/foo.jpg`
 *   - already-absolute URLs (returned as-is)
 *   - bare filenames combined with a category (use `toUploadUrl('logos', name)`)
 */
export function toUploadUrl(pathOrCategory: string, filename?: string): string {
  if (!pathOrCategory) return '';

  if (filename) {
    // Two-arg form: category + filename
    return `${BACKEND_HOST}/uploads/${pathOrCategory}/${filename}`;
  }

  // Single-arg form: a path that may or may not start with / or http(s)://
  if (/^https?:\/\//i.test(pathOrCategory)) return pathOrCategory;

  const trimmed = pathOrCategory.startsWith('/') ? pathOrCategory : `/${pathOrCategory}`;
  return `${BACKEND_HOST}${trimmed}`;
}
